import { render, staticRenderFns } from "./settings-organization-phone-numbers.vue?vue&type=template&id=d4bd7658&scoped=true&"
import script from "./settings-organization-phone-numbers.vue?vue&type=script&lang=js&"
export * from "./settings-organization-phone-numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd7658",
  null
  
)

export default component.exports